import { Product } from "@utilities/types";

export const getProductSellingPrice = (product: Product) => {
    return product.productSellingPrices[
        product.productSellingPrices.length - 1
    ]?.price || 0;
}
